import React from "react";
import { LANDING } from "@/constants/testIds";
import { ArrowRight, Phone, ShieldCheck } from "lucide-react";

const heroImage =
  "https://images.unsplash.com/photo-1600531529272-023c4b821f14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnbGFzcyUyMG9mZmljZSUyMGFyY2hpdGVjdHVyZSUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4MjM5OTg2Nnww&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid={LANDING.hero}
      className="relative pt-16 md:pt-24 pb-24 md:pb-32 px-6 md:px-12 lg:px-24"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
        {/* Left: copy */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-8">
            <span className="inline-flex h-2 w-2 rounded-full bg-accent" />
            <span className="label-eyebrow">
              Group benefits · Commercial coverage · Since 2025
            </span>
          </div>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-[5.25rem] h-tight font-light text-foreground">
            Insurance for the businesses{" "}
            <span className="font-black italic text-accent">that build</span>{" "}
            things worth protecting.
          </h1>

          <p className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-muted-foreground">
            Key Legacy Protection is a specialist brokerage for owner-led
            companies. We design key person coverage, group life, workers&apos;
            comp and commercial insurance that holds up when claims happen —
            without the bloat of legacy brokers.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <a
              href="#quote"
              data-testid={LANDING.heroCtaQuote}
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3.5 rounded-md text-sm font-semibold hover:bg-[#1F1F1F] hover:-translate-y-0.5 transition-all duration-300"
            >
              Get a tailored quote
              <ArrowRight size={16} />
            </a>
            <a
              href="#contact"
              data-testid={LANDING.heroCtaTalk}
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md text-sm font-semibold border border-border bg-transparent text-foreground hover:bg-secondary transition-colors"
            >
              <Phone size={16} />
              Talk to a broker
            </a>
          </div>

          <div className="mt-10 flex items-start gap-3 max-w-md text-xs text-muted-foreground">
            <ShieldCheck
              size={16}
              className="mt-0.5 shrink-0 text-primary"
              aria-hidden
            />
            <p>
              Licensed in 38 states · NAIC #38211 · Errors &amp; Omissions
              coverage maintained at $5M.
            </p>
          </div>
        </div>

        {/* Right: image card + stats */}
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="relative aspect-[4/5] overflow-hidden rounded-md border border-accent/40 bg-secondary ring-1 ring-accent/20 ring-offset-2 ring-offset-background">
              <img
                src={heroImage}
                alt="Modern office building representing Key Legacy Protection's business clients"
                className="absolute inset-0 w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="font-display text-3xl font-bold text-white tracking-tight">
                  $5M
                </p>
                <p className="text-xs uppercase tracking-[0.2em] text-white/80 mt-1">
                  Coverage placed since 2025
                </p>
              </div>
            </div>

            <div className="absolute -bottom-8 -left-6 hidden md:block">
              <div className="bg-background border border-border rounded-md p-5 shadow-sm w-56 relative">
                <span className="absolute -top-2 -left-2 h-3 w-3 bg-accent rounded-sm rotate-45" />
                <p className="font-display text-3xl font-bold text-foreground">
                  110+
                </p>
                <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-1">
                  Businesses insured
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
